var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8E64A",
    fillRule: "evenodd",
    d: "M9.386 1.501a.996.996 0 0 1 1.729 0l7.75 13.5a1 1 0 0 1-.864 1.499H2.499a1 1 0 0 1-.864-1.5zm-.088 5.49a.954.954 0 1 1 1.904 0l-.17 3.758a.784.784 0 0 1-1.564 0zm.952 5.508a1 1 0 0 0-.998 1 .999.999 0 1 0 1.995 0c0-.552-.446-1-.997-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconWarning;